/* eslint-disable lines-between-class-members */
import { FpjsClient } from '@fingerprintjs/fingerprintjs-pro-spa';
import APP_DEFAULTS from '../constants/app-defaults';

/**
 * Service to interact with Fingerprint.
 * It implements a singleton to avoid duplicated api calls.
 */
class FingerprintService {
    static _info = null;

    static get info() {
        if (FingerprintService._info !== null) {
            return new Promise((resolve, reject) => resolve(FingerprintService._info));
        }
        const fpClient = new FpjsClient({
            loadOptions: {
                apiKey: process.env.REACT_APP_FINGERPRINT_PUBLIC_KEY,
                endpoint: process.env.REACT_APP_FINGERPRINT_ENDPOINT,
            },
        });

        return new Promise((resolve, reject) => {
            const visitorData = fpClient.init().then(() => fpClient.getVisitorData({ extendedResult: true }));
            visitorData.then(
                (info) => {
                    FingerprintService._info = info;
                    return resolve(info);
                },
            ).catch((err) => {
                // we must resolve with null even if Fingerprint fails to provide us the user's info
                console.error(err);
                resolve(null);
            });
        });
    }
}

export default FingerprintService;



/** WEBPACK FOOTER **
 ** ./src/services/fingerprint-service.js
 **/